import { QualityControlValidation } from "@/components/QualityControlValidation";

export default function QualityControl() {
  return <QualityControlValidation />;
}